import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import "./css/style.css";
import "./css/comments_suggest.css";
import { setSurveyCommentTag } from "./actions";

export default function CommentSuggest() {
  const dispatch = useDispatch();
  const surveyPoint = useSelector((state) => state.surveyPoint);
  const [currentPoint, setCurrentPoint] = useState(null);
  const [commentData, setCommentData] = useState(null);
  const [commentIDSelect, setCommentIDSelect] = useState([]);
  const [commentSelect, setCommentSelect] = useState("");

  useEffect(() => {
    if (commentData === null) {
      fetchCommentAPI();
    }
    async function fetchCommentAPI() {
      const response = await axios.get(`${process.env.REACT_APP_URL_API}/textadvice`, { headers: { "Access-Control-Allow-Origin": "*" } });
      if (response.data.status !== "FAIL") {
        setCommentData(response.data.data);
      }
    }
  }, [commentData]);

  const handleCommentSelect = (value, id) => {
    setCommentSelect(value);
  };
  useEffect(() => {
    dispatch(setSurveyCommentTag(commentSelect));
  }, [commentSelect, dispatch]);

  useEffect(() => {
    if (currentPoint !== surveyPoint.point) {
      setCurrentPoint(surveyPoint.point);
      setCommentIDSelect([]);
      setCommentSelect("");
    }
  }, [surveyPoint.point, currentPoint]);

  const CreateCommnetSelect = () => {
    if (commentData !== null) {
      const data = commentData.map((listData, index) => {
        if (surveyPoint.point === listData.point) {
          return (
            <button
              type="button"
              id={`${listData.id}`}
              key={listData.id}
              className={`btn btn-outline-secondary shadow-none comment_tag ${commentIDSelect.includes(listData.id + "") ? "comment_select" : ""}`}
              onClick={(event) => handleCommentSelect(event.target.innerText, `${listData.id}`)}
            >
              {listData.text}
            </button>
          );
        }
        return null;
      });
      return data;
    }
    return <></>;
  };

  return (
    <>
      <CreateCommnetSelect />
    </>
  );
}
